import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-comp-jquiresizable',
	templateUrl:'./JQUIResizablePage.html',
	styles: [],
	styleUrls:['./JQUIResizablePage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class JQUIResizablePage
{
	mdContent_210 = `\`\`\`java
import com.jwebmp.plugins.jqueryui.resizable.JQUIResizable;
\`\`\``;
	mdContent_211 = `\`\`\`java
new JQUIResizable&lt;&gt;()
\`\`\``;
	mdContent_212 = `\`\`\`java
var box = new JQUIResizable<>();
box.setText("Resize me");
box.getOptions().setAspectRatio(true);
\`\`\``;
}
